import React, { useEffect, useRef } from 'react';

import styles from './onboarding.module.css';
import { CHECKLIST_ITEMS } from './onboardingSteps';
import { getLocale } from './locales';
import { useOnboarding } from './onboardingContext';

// Ð§ÐµÐº-Ð»Ð¸ÑÑ Ð¿ÐµÑÐ²ÑÑ ÑÐ°Ð³Ð¾Ð²: ÐºÐ¾ÑÐ¾ÑÐºÐ¸Ð¹ Ð¿ÑÑÑ Ð´Ð¾ Ð¿ÐµÑÐ²Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð±Ð°Ð½ÐºÐ¸.
// ÐÐ¸ÑÐ¸Ñ Ð² ÑÐ³Ð»Ñ, Ð¿ÑÑÑÐµÑÑÑ Ð¿Ð¾ ÐºÐ½Ð¾Ð¿ÐºÐµ Ð¸ ÑÐ°Ð¼ Ð¸ÑÑÐµÐ·Ð°ÐµÑ, ÐºÐ¾Ð³Ð´Ð° Ð²ÑÑ ÑÐ´ÐµÐ»Ð°Ð½Ð¾.

const OnboardingChecklist = () => {
  const { checklistDone, checklistHidden, hideChecklist, allChecklistDone, tourRunning } = useOnboarding();
  const locale = getLocale();

  // ÐÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¾ â ÑÐ±Ð¸ÑÐ°ÐµÐ¼ ÑÐ°Ð¼Ð¸, Ð½Ð¾ Ð½Ðµ Ð² ÑÑ Ð¶Ðµ ÑÐµÐºÑÐ½Ð´Ñ: Ð¿ÑÑÑÑ ÑÐµÐ»Ð¾Ð²ÐµÐº
  // ÑÐ²Ð¸Ð´Ð¸Ñ, ÑÑÐ¾ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¹ Ð¿ÑÐ½ÐºÑ Ð·Ð°ÐºÑÑÐ»ÑÑ.
  const hideTimer = useRef(null);

  useEffect(() => {
    if (!allChecklistDone || checklistHidden) return undefined;

    hideTimer.current = setTimeout(() => hideChecklist('completed'), 2000);
    return () => clearTimeout(hideTimer.current);
  }, [allChecklistDone, checklistHidden, hideChecklist]);

  // ÐÐ¾ Ð²ÑÐµÐ¼Ñ ÑÑÑÐ° Ð½Ðµ Ð·Ð°Ð³Ð¾ÑÐ°Ð¶Ð¸Ð²Ð°ÐµÐ¼ ÑÐºÑÐ°Ð½.
  if (checklistHidden || tourRunning) return null;

  const done = checklistDone.length;
  const total = CHECKLIST_ITEMS.length;
  const percent = Math.round((done / total) * 100);

  return (
    <aside className={styles.checklist} aria-label={locale.checklist.title} data-testid="onboarding-checklist">
      <div className={styles.checklistHead}>
        <h2 className={styles.checklistTitle}>{locale.checklist.title}</h2>
        <button type="button" className={styles.skip} onClick={() => hideChecklist('manual')}>
          {locale.checklist.hide}
        </button>
      </div>

      <p className={styles.checklistSubtitle}>{allChecklistDone ? locale.checklist.done : locale.checklist.subtitle}</p>

      <div
        className={styles.progressTrack}
        role="progressbar"
        aria-valuenow={done}
        aria-valuemin={0}
        aria-valuemax={total}
      >
        <div className={styles.progressBar} style={{ width: `${percent}%` }} />
      </div>

      <ul className={styles.checklistItems}>
        {CHECKLIST_ITEMS.map((item) => {
          const isDone = checklistDone.includes(item);

          return (
            <li key={item} className={`${styles.checklistItem} ${isDone ? styles.checklistItemDone : ''}`}>
              <span className={`${styles.mark} ${isDone ? styles.markDone : ''}`} aria-hidden="true">
                {isDone ? 'â' : ''}
              </span>
              {locale.checklist.items[item]}
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default OnboardingChecklist;
